import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { adsContext } from '../UseContext/AdsContext';


const BasicInfo = () => {

  const navigate = useNavigate();

const { ad, setAd } = useContext(adsContext);

  return (
    <>
      <section className='d-flex flex-column flex-xl-row gap-3 mb-3'>
        {/* Left Block */}
        <div className='create-campaign-left-block bg-light p-3 rounded-3 shadow-sm'>
          {/* Select Page */}
          <div className='mb-4'>
            <h5 className='mb-0'>Select Page</h5>

            <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

            <select className="form-select mt-1" value={ad.page} onChange={(e) => setAd({ ...ad, page: e.target.value })}>
              <option value='' disabled>Select your page</option>
              <option value="business-page-1">Business Page 1</option>
              <option value="business-page-2">Business Page 2</option>
              <option value="business-page-3">Business Page 3</option>
              <option value="business-page-4">Business Page 4</option>
              <option value="business-page-5">Business Page 5</option>
            </select>
          </div>

          {/* Ad Name */}
          <div className='mb-4'>
            <h5 className='mb-0'>Ad Name</h5>

            <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

            <input type="text" className='form-control mt-1' value={ad.name} onChange={(e) => setAd({ ...ad, name: e.target.value })} placeholder='Enter your ad name...' />
          </div>

          {/* Select Goal */}
          <div className='mb-4'>
            <h5 className='mb-0'>Select Goal</h5>

            <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

            <select className="form-select mt-1" value={ad.goal} onChange={(e) => setAd({ ...ad, goal: e.target.value })}>
              <option value='' disabled>Select your goal</option>
              <option value="goal-1">Maximize reach of ads</option>
              <option value="goal-2">Maximize number of impression</option>
              <option value="goal-3">Maximize ad recall it</option>
            </select>
          </div>

          {/* Ad Description */}
          <div className='mb-4'>
            <h5 className='mb-2'>Ad Description</h5>

            <div className="form-floating">
              <textarea className="form-control" value={ad.description} onChange={(e) => setAd({ ...ad, description: e.target.value })} id="floatingTextarea2" style={{ height: '100px' }} placeholder="Ad Description..."></textarea>
              <label htmlFor="floatingTextarea2">Ad Description</label>
            </div>
          </div>

          {/* Buttons */}
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <button type="button" className='btn btn-success flex-grow-1'>Save Draft</button>
            <button type="button" className='btn bg-secondary-subtle flex-grow-1'>Cancel</button>
            <button type="button" className='btn btn-primary flex-grow-1' onClick={() => navigate(`/campaigns/media`)}>Next</button>
          </div>
        </div>

        {/* Right Block */}
        <div className='create-campaign-right-block bg-light p-3 rounded-3 shadow-sm'>Right Block</div>
      </section> 
    </>
  );
};

export default BasicInfo;